import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool, oneOf, string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Toast from '@taglivros/oef_componentes/build/components/toast'

import { useGlobal } from '../../contexts/GlobalContext'

const estiloLogado = `
  margin-top: 10px;

  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 25px 0 5px;
    width: 100%;
  }
`

const WrapperToastGeral = styled.div`
  width: 100%;

  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 20px auto 0;
    max-width: 1172px;
  }

  ${( { logado } ) => logado && estiloLogado}
`

const ToastGeral = ( { mensagem, show, tipoToast } ) => {
  const { isAssociadoLogado } = useGlobal()
  const [ showToast, setShowToast ] = useState( false )

  useEffect( () => {
    setShowToast( show )
  }, [ show ] )

  return (
    <WrapperToastGeral
      logado={ isAssociadoLogado }
    >
      <Toast
        close={ () => setShowToast( false ) }
        fullWidth
        message={ mensagem }
        show={ showToast }
        type={ tipoToast }
      />
    </WrapperToastGeral>
  )
}

ToastGeral.defaultProps = {
  'show': false
}

ToastGeral.propTypes = {
  'mensagem': string.isRequired,
  'show': bool,
  'tipoToast': oneOf( [ Toast.ERROR, Toast.SUCCESS ] ).isRequired
}

export default ToastGeral
